module.exports = __webpack_public_path__ + "img/N03zp80Fnek.4bf8b992.jpg";